import { z } from 'zod';
export const DSLMatchQueryDTO = z.object({
  match: z.record(
    z.string(),
    z.union([
      z.string(),
      z.object({
        query: z.string(),
        operator: z.enum(['and', 'or']).optional(),
        boost: z.number().optional(),
      }),
    ]),
  ),
});

export type DSLMatchQuery = z.infer<typeof DSLMatchQueryDTO>;